import { ReactComponent as Logo } from '../assets/svg/logo.svg';

export const Inspection = () => {
  return (
        <div className="inspection_h text-center text-12 -mx-4">
            <ul className="flex flex-col">
                <li className="border-b border-gray-100 bg-brand-1">
                  <Logo className="cursor-pointer m-auto w-36 my-5"/>
                </li>
            </ul>
            <ul className="flex flex-col justify-center h-full">
                <li className="md:text-8xl text-3xl font-bold text-black opacity-80">시스템 업데이트 중 입니다.</li>
                <li className="md:text-8xl text-3xl font-bold md:mt-2 mt-0 md:mb-36 mb-20 tx_3e52bb">잠시만 기다려주세요.</li>
                {/*<li className="font-bold mb-1"><span className="tx_3e52bb">11월 16일(수) 오전 11시 ~ 오후 2시 (총 3시간)</span></li>*/}
                <li className="text-gray-400">작업 상황에 따라 일정은 변경 될 수 있습니다.</li>
            </ul>
        </div>
  );
};

